// Attuned remedy pages (sections/ah-remedy, ah-remedy-info, ah-remedy-plan) and the Remedies collection (sections/ah-remedies.liquid), from the approved stills.
// Product: sections settle in, the start-low bars and the series vials draw, hero links scroll, variants and Add to cart open the
// theme's cart drawer, the phone buy bar appears once the buy panel has passed, and a "Back to your results" bar shows for visitors
// who came from their results. Collection: loads every remedy from sections/ahr-index.liquid so the form chips, search and Show more
// cover the whole collection.
(() => {
  const esc = t => String(t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  function frame(root) {
    const hdrEl = document.querySelector('.header-wrapper') || document.querySelector('.section-header');
    const set = () => {
      root.style.setProperty('--vh', innerHeight + 'px');
      root.style.setProperty('--hdr', (hdrEl ? Math.max(0, Math.round(hdrEl.getBoundingClientRect().bottom)) : 0) + 'px');
    };
    set(); addEventListener('resize', set);
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .15 });
    const watch = el => reduce() ? el.classList.add('in') : io.observe(el);
    root.querySelectorAll('.rv,[data-bars],[data-vials]').forEach(watch);
    root.addEventListener('click', e => {
      const a = e.target.closest('[data-go]'); if (!a) return;
      const t = document.getElementById(a.dataset.go); if (!t) return;
      e.preventDefault();
      t.querySelectorAll('.rv').forEach(x => x.classList.add('in'));
      t.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
    });
    return watch;
  }

  function product(root) {
    if (root.dataset.ahrReady) return; root.dataset.ahrReady = '1';
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    frame(root);

    // came from their results (the results app passes ?from=results, or the visit came from the app's pages)
    const from = $('[data-from]');
    const ref = document.referrer || '';
    if (from && (/[?&]from=results\b/.test(location.search) || /\/apps\/attuned\/|\/pages\/view-results/.test(ref))) {
      from.hidden = false;
      const back = $('[data-from-back]');
      if (back && /\/apps\/attuned\//.test(ref)) back.href = ref;
    }

    // variants: the chosen one goes to every Add to cart, and its price to the button and the buy bar
    const opts = $$('.opt[data-variant]');
    const atcs = $$('[data-atc]');
    opts.forEach(o => o.addEventListener('click', () => {
      if (o.classList.contains('solo')) return;
      opts.forEach(x => x.classList.toggle('sel', x === o));
      const inp = o.querySelector('input'); if (inp) inp.checked = true;
      atcs.forEach(b => b.dataset.variantId = o.dataset.variant);
      if (o.dataset.price) $$('[data-atc-price]').forEach(e => e.textContent = o.dataset.price);
    }));
    atcs.forEach(btn => btn.addEventListener('click', async () => {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      const err = $('[data-err]');
      btn.setAttribute('aria-disabled', 'true'); if (err) err.hidden = true;
      try {
        const r = await fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.variantId, quantity: 1 }] }) });
        const d = await r.json();
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to cart. Please try again.');
        if (typeof updateCartCounts === 'function') updateCartCounts();
        if (typeof loadEgCartDrawer === 'function') loadEgCartDrawer(); else location.href = '/cart';
      } catch (x) { if (err) { err.textContent = x.message; err.hidden = false; } }
      finally { btn.removeAttribute('aria-disabled'); }
    }));

    // phone buy bar, once the buy panel's facts have scrolled past
    const dock = $('[data-dock]'), end = $('.buy .facts') || $('.buy');
    if (dock && end) {
      const tick = () => dock.classList.toggle('on', end.getBoundingClientRect().bottom < 0);
      addEventListener('scroll', () => requestAnimationFrame(tick), { passive: true }); tick();
    }
  }

  function collection(root) {
    if (root.dataset.ahrReady) return; root.dataset.ahrReady = '1';
    const $ = s => root.querySelector(s);
    const watch = frame(root);
    const grid = $('[data-grid]'), chips = $('[data-chips]'), q = $('[data-q]'), more = $('[data-showmore]');
    const count = $('[data-count]'), prog = $('[data-prog]'), sortSel = $('[data-sortsel]');
    const per = +root.dataset.per || 24, signedIn = root.dataset.customer === '1';
    const tile = grid.querySelector('[data-tile]'), tileAt = tile ? [...grid.children].indexOf(tile) : -1;
    const firstHTML = grid.innerHTML;
    let all = null, form = '', shown = grid.querySelectorAll('.card').length;

    // sort reloads the page server-side, keeping the order the index is fetched in
    if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u; });

    const card = c => `<a class="card rv in" href="${esc(c.u)}"><div class="plinth" style="--nat:${c.n}px">${c.i ? `<img src="${esc(c.i)}" alt="${esc(c.t)}" loading="lazy">` : ''}</div><div class="nm">${esc(c.t)}</div><div class="mt"><span>${esc(c.f)}</span><span class="pr${c.p ? '' : ' si'}">${c.p ? esc(c.p) : (signedIn ? '' : 'Sign in for price')}</span></div></a>`;
    const list = () => {
      const t = (q && q.value.trim().toLowerCase()) || '';
      return all.filter(c => (!form || c.f === form) && (!t || c.t.toLowerCase().includes(t) || c.full.toLowerCase().includes(t)));
    };
    function render(reset) {
      const L = list(), t = q && q.value.trim();
      if (reset) shown = Math.min(per, L.length);
      const plain = !form && !t;
      if (!L.length) {
        grid.innerHTML = `<p class="none"><b>Nothing called “${esc(t)}”${form ? ` in ${esc(form)}` : ''}</b>Try part of the name, like “drainage” or “tox”.</p>`;
      } else {
        const cards = L.slice(0, shown).map(card);
        if (plain && tile && tileAt >= 0 && tileAt <= cards.length) cards.splice(tileAt, 0, tile.outerHTML);
        grid.innerHTML = cards.join('');
        grid.querySelectorAll('.rv').forEach(e => e.classList.add('in'));
      }
      if (count) count.textContent = plain ? `${Math.min(shown, L.length)} of ${L.length}` : `${L.length} ${L.length === 1 ? 'remedy' : 'remedies'}${t ? ' found' : ''}`;
      if (prog) prog.style.width = (L.length ? Math.min(shown, L.length) / L.length * 100 : 0) + '%';
      if (more) more.hidden = shown >= L.length;
    }

    // the whole collection, 250 a page, from the index section (same sort as the page)
    async function load() {
      const sort = root.dataset.sort ? `&sort_by=${encodeURIComponent(root.dataset.sort)}` : '';
      const get = async p => {
        const r = await fetch(`/collections/${root.dataset.handle}?sections=ahr-index&page=${p}${sort}`);
        const html = (await r.json())['ahr-index'];
        const d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ahr-index]');
        return { items: JSON.parse(d.textContent), pages: +d.dataset.pages || 1 };
      };
      const first = await get(1); let items = first.items;
      for (let p = 2; p <= first.pages; p++) items = items.concat((await get(p)).items);
      return items;
    }
    load().then(items => {
      all = items;
      const order = ['Drops', 'Capsules', 'Powder', 'Spray', 'Series'], names = { Powder: 'Powders', Spray: 'Sprays' };
      const counts = {}; all.forEach(c => { if (c.f) counts[c.f] = (counts[c.f] || 0) + 1; });
      order.filter(f => counts[f]).forEach(f => {
        const b = document.createElement('button'); b.type = 'button'; b.dataset.f = f;
        b.innerHTML = `${names[f] || f}<sup>${counts[f]}</sup>`; chips.append(b);
      });
      chips.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return;
        form = b.dataset.f; chips.querySelectorAll('button').forEach(x => x.classList.toggle('on', x === b)); render(true);
      });
      if (q) q.addEventListener('input', () => { if (!q.value.trim() && !form) { grid.innerHTML = firstHTML; grid.querySelectorAll('.rv').forEach(watch); shown = grid.querySelectorAll('.card').length; render(false); } else render(true); });
      if (more) more.addEventListener('click', e => { e.preventDefault(); shown += per; render(false); });
      if (count) count.textContent = `${shown} of ${all.length}`;
      if (prog) prog.style.width = (shown / all.length * 100) + '%';
    }).catch(() => { /* without the index the page keeps its server pages: Show more links to page 2 */ });
  }

  const boot = () => {
    document.querySelectorAll('[data-ahr]').forEach(product);
    document.querySelectorAll('[data-ahr-part]').forEach(r => { if (!r.dataset.ahrReady) { r.dataset.ahrReady = '1'; frame(r); } });
    document.querySelectorAll('[data-ahrc]').forEach(collection);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

// preview review only: &notes=1 loads the notes tool (assets/ahr-notes.js, theme copy only; where that file doesn't exist this does nothing)
if (/[?&]notes=1\b/.test(location.search)) { const me = document.currentScript && document.currentScript.src; if (me) { const s = document.createElement('script'); s.src = me.split('?')[0].replace('ah-remedy.js', 'ahr-notes.js') + '?t=' + Date.now(); document.head.appendChild(s); } }